import React, { FC, ReactNode } from 'react';
import './SubmitButton.css';
import { ActionButton } from '..';

interface SubmitButtonProps {
	onClick?: () => void;
	isLoading?: boolean;
	icon?: ReactNode,
	tooltip? : string,
	disabled? : boolean,
	label? : string
	type? : "button" | "submit"
}

const SubmitButton: FC<SubmitButtonProps> = ({ 
	onClick, 
	isLoading, 
	icon, 
	tooltip = "Bouton d'envoi du formulaire",
	disabled,
	label = "Enregistrer",
	type="submit"
}) => (
	<ActionButton
		classNames="SubmitButton submit-button"
		icon={icon}
		label={label}
		onClick={onClick}
		isLoading={isLoading}
		tooltip={tooltip ?? "Cliquer pour soumettre le formulaire"}
		showLabel
		disabled={disabled}
		type={type}
	/>
);

export default SubmitButton;
